// 底栏指向移远官网，不随本地、测试或部署环境改变。
const host = 'https://www.quectel.com.cn'
const module = [
  {
    title: '模组与天线',
    links: [
      {
        name: '5G',
        link: 'https://www.quectel.com.cn/product-category/5g-modules-cn',
      },
      {
        name: '4G',
        link: 'https://www.quectel.com.cn/product-category/4g-modules-cn',
      },
      {
        name: 'LPWA',
        link: 'https://www.quectel.com.cn/product-category/lpwa-modules-cn',
      },
      {
        name: '3G/2G',
        link: 'https://www.quectel.com.cn/product-category/2g-modules-cn',
      },
      {
        name: 'GNSS',
        link: 'https://www.quectel.com.cn/product-category/standalone-gnss-cn',
      },
      {
        name: '卫星通信',
        link: 'https://www.quectel.com.cn/product-category/satellite-communication',
      },
      {
        name: '车载',
        link: 'https://www.quectel.com.cn/product-category/automotive-modules-cn',
      },
      {
        name: '智能',
        link: 'https://www.quectel.com.cn/product-category/smart-modules-cn',
      },
      {
        name: '短距离',
        link: 'https://www.quectel.com.cn/product-category/wi-fi-modules-cn',
      },
      {
        name: '天线',
        link: 'https://www.quectel.com.cn/product-category/antenna',
      },
      { name: 'EVB', link: 'https://www.quectel.com.cn/product-category/evb' },
      { name: '产品选型', link: 'https://www.quectel.com.cn/shop' },
    ],
  },
  {
    title: '服务与方案',
    links: [
      {
        name: '物联网平台',
        link: 'https://www.quectel.com.cn/services-solutions/iot-platform',
      },
      {
        name: '工业智能',
        link: 'https://www.quectel.com.cn/services-solutions/industrial-intelligence',
      },
      {
        name: '智慧农业',
        link: 'https://www.quectel.com.cn/services-solutions/smart-agriculture',
      },
      {
        name: '天线服务',
        link: 'https://www.quectel.com.cn/services-solutions/antenna',
      },
      {
        name: '认证与测试服务',
        link: 'https://www.quectel.com.cn/services-solutions/certification-and-testing',
      },
      {
        name: 'RTK网络校正方案',
        link: 'https://www.quectel.com.cn/services-solutions/quecrtk',
      },
      {
        name: '移远智能制造服务',
        link: 'https://www.quectel.com.cn/services-solutions/yiyuan-intelligent-manufacturing-center',
      },
      {
        name: 'XR解决方案',
        link: 'https://www.quectel.com.cn/services-solutions/xr',
      },
      {
        name: '移远商城',
        link: 'https://www.quectel.com.cn/services-solutions/quectel-mall',
      },
    ],
  },
  {
    title: '行业应用',
    links: [
      { name: 'FWA', link: 'https://www.quectel.com.cn/employ/fwa' },
      { name: '金融支付', link: 'https://www.quectel.com.cn/employ/payment' },
      {
        name: '智慧能源',
        link: 'https://www.quectel.com.cn/employ/smart-metering-and-smart-grid',
      },
      {
        name: '资产跟踪',
        link: 'https://www.quectel.com.cn/employ/asset-tracking',
      },
      {
        name: '智慧交通',
        link: 'https://www.quectel.com.cn/employ/automotive',
      },
      {
        name: '车载信息服务',
        link: 'https://www.quectel.com.cn/employ/commercial_telematics',
      },
      {
        name: '数字标牌',
        link: 'https://www.quectel.com.cn/employ/digital_signage',
      },
      {
        name: '远程医疗',
        link: 'https://www.quectel.com.cn/employ/telehealth',
      },
      {
        name: '远程监测与控制',
        link: 'https://www.quectel.com.cn/employ/rmac',
      },
    ],
  },
  {
    title: '技术支持',
    links: [
      { name: 'QTSS服务', link: 'https://www.quectel.com.cn/qtss-service' },
      { name: '下载专区', link: 'https://www.quectel.com.cn/download-zone' },
      {
        name: '技术论坛',
        link: 'https://forumschinese.quectel.com/',
        target: '_blank',
      },
      { name: '常见问题', link: 'https://www.quectel.com.cn/faqs' },
      {
        name: '移远开源',
        link: 'https://www.quectel.com.cn/quectel-open-source',
      },
      {
        name: 'IMEI验证',
        link: 'https://market.quectel.com/imei-verification/',
      },
      { name: '技术支持', link: 'https://www.quectel.com.cn/contact?tab=t' },
      {
        name: '建议和投诉',
        link: 'https://www.quectel.com.cn/suggestions-and-complaints',
      },
      { name: '会员中心', link: 'https://www.quectel.com.cn/member-center' },
    ],
  },
  {
    title: '开发者生态',
    links: [
      {
        name: 'Quectel Pi',
        link: 'https://www.quectel.com.cn/quectel-pi/quectel-pi',
      },
      {
        name: 'QuecPython',
        link: 'https://www.quectel.com.cn/quecpython/quecpython',
      },
      {
        name: 'UniKnect',
        link: 'https://www.quectel.com.cn/uniknect/uniknect',
      },
      { name: 'UniRTOS', link: 'https://www.quectel.com.cn/unirtos/unirtos' },
      {
        name: 'AI开放平台',
        link: 'https://www.quectel.com.cn/ai-open-platform/home',
        target: '_blank',
      },
      {
        name: '飞鸢物联网平台',
        link: 'https://www.quectel.com.cn/iotplatform/iot-platform',
      },
      {
        name: '开发板与硬件',
        link: 'https://www.quectel.com.cn/devboard_and_hardware',
      },
    ],
  },
  {
    title: '大学计划',
    links: [
      {
        name: '大学生嵌入式竞赛',
        link: 'https://www.quectel.com.cn/university-plan/embedded-competition',
      },
      {
        name: '大学生物联网竞赛',
        link: 'https://www.quectel.com.cn/university-plan/iot-competition',
      },
    ],
  },
  {
    title: '仪器仪表',
    links: [
      {
        name: 'Power Mini 直流功耗仪',
        link: 'https://www.quectel.com.cn/instrument-overall/quectel_power_mini_dc_power_analyzer',
      },
    ],
  },
  {
    title: '关于移远',
    links: [
      { name: '公司简介', link: 'https://www.quectel.com.cn/company' },
      {
        name: '投资者关系',
        link: 'https://www.quectel.com.cn/company/investor-relations',
      },
      {
        name: '合作伙伴',
        link: 'https://www.quectel.com.cn/strategic-partners',
      },
      {
        name: '安全与认证',
        link: 'https://www.quectel.com.cn/security-certification',
      },
      {
        name: '加入移远',
        link: 'https://www.quectel.com.cn/company/join-quectel',
      },
      {
        name: '研发中心',
        link: 'https://www.quectel.com.cn/company/rd-center',
      },
    ],
  },
  {
    title: '新闻资讯',
    links: [
      { name: '新闻动态', link: 'https://www.quectel.com.cn/news' },
      {
        name: '应用案例',
        link: 'https://www.quectel.com.cn/application-cases',
      },
      { name: '技术资源', link: 'https://www.quectel.com.cn/tech-features' },
      { name: '市场活动', link: 'https://www.quectel.com.cn/events' },
      { name: '技术课堂', link: 'https://www.quectel.com.cn/micro-classroom' },
    ],
  },
]

const server = [
  {
    name: '物联网平台',
    link: `${host}/services-solutions/iot-platform`,
  },
  {
    name: '工业智能',
    link: `${host}/services-solutions/industrial-intelligence`,
  },
  {
    name: '智慧农业',
    link: `${host}/services-solutions/smart-agriculture`,
  },
  {
    name: '天线服务',
    link: `${host}/services-solutions/antenna`,
  },
  {
    name: '认证与测试服务',
    link: `${host}/services-solutions/certification-and-testing`,
  },
  {
    name: 'RTK网络校正方案',
    link: `${host}/services-solutions/quecrtk`,
  },
  {
    name: '移远智能制造中心',
    link: `${host}/services-solutions/yiyuan-intelligent-manufacturing-center`,
  },
]

const core = [
  {
    name: 'QuecPython',
    link: `${host}/quecpython/quecpython`,
  },
  {
    name: 'AI开放平台',
    link: `${host}/ai-open-platform/home`,
    target: '_blank',
  },
]

const industry = [
  {
    name: 'FWA',
    link: `${host}/employ/fwa`,
  },
  {
    name: '金融支付',
    link: `${host}/employ/payment`,
  },
  {
    name: '智慧能源',
    link: `${host}/employ/smart-metering-and-smart-grid`,
  },
  {
    name: '资产跟踪',
    link: `${host}/employ/asset-tracking`,
  },
  {
    name: '智慧交通',
    link: `${host}/employ/automotive`,
  },
  {
    name: '车载信息服务',
    link: `${host}/employ/commercial_telematics`,
  },
  {
    name: '数字标牌',
    link: `${host}/employ/digital_signage`,
  },
  {
    name: '远程医疗',
    link: `${host}/employ/telehealth`,
  },
  {
    name: '远程监测与控制',
    link: `${host}/employ/rmac`,
  },
]

const support = [
  {
    name: 'QTSS服务',
    link: `${host}/qtss-service`,
  },
  {
    name: '下载专区',
    link: `${host}/download-zone`,
  },
  {
    name: '技术论坛',
    link: `https://forumschinese.quectel.com/`,
    target: '_blank',
  },
  {
    name: '常见问题',
    link: `${host}/faqs`,
  },
  {
    name: '移远开源',
    link: `${host}/quectel-open-source`,
  },
  {
    name: 'IMEI验证',
    link: 'https://market.quectel.com/imei-verification/',
  },
  {
    name: '技术支持',
    link: `https://www.quectel.com.cn/contact?tab=t`,
  },
  {
    name: '建议和投诉',
    link: `${host}/suggestions-and-complaints`,
  },
  {
    name: '会员中心',
    link: `${host}/member-center`,
  },
]

const quectel = [
  {
    name: '公司简介',
    link: `${host}/company`,
  },
  {
    name: '投资者关系',
    link: `${host}/company/investor-relations`,
  },
  {
    name: '合作伙伴',
    link: `${host}/strategic-partners`,
  },
  {
    name: '安全与认证',
    link: `${host}/security-certification`,
  },
  {
    name: '加入移远',
    link: `${host}/company/join-quectel`,
  },
  {
    name: '研发中心',
    link: `${host}/company/rd-center`,
  },
  {
    name: '招标公告',
    link: `${host}/company/2024-financial-statements-and-internal-control-audit-project-invitation-tender-announcement`,
  },
  {
    name: '在线商城',
    link: 'https://yiyuanznsb.tmall.com/shop/view_shop.htm',
  },
]

const news = [
  {
    name: '新闻动态',
    link: `${host}/news`,
  },
  {
    name: '技术资源',
    link: `${host}/tech-features`,
  },
  {
    name: '市场活动',
    link: `${host}/events`,
  },
  {
    name: '技术课堂',
    link: `${host}/micro-classroom`,
  },
]

export { module, server, news, quectel, core, support, industry }
